<template>
	<div>
		<div class="row mb-3">
			<div class="col-12">
				<h1><em class="fas fa-bus-alt"></em> Accessible and Special Education Transportation Registration Forms</h1>
			</div>
		</div>

		<div class="row mb-3">
			<div class="col-4">
				<label for="filter_school_id" class="font-weight-bold">School</label>
				<div v-if="schools.length == 1">{{schools[0].school_name}}</div>

				<select class="form-control custom-select custom-select-sm" v-model="filters.school_id" id="filter_school_id" v-if="schools.length > 1" @change="saveFilters();page=1;loadForms()">
					<option :value="null">All Schools</option>
					<option v-for="s in schools" :key="s.school_id" :value="s.school_id">{{s.school_name}}</option>
				</select>
			</div>
			<div class="col-4">
				<label for="filter_active" class="font-weight-bold">Status</label>
				<div class="btn-group d-block mb-2" role="group" aria-label="Active / Inactive">
					<button type="button" class="btn btn-sm" :class="{'btn-success': filters.active == 1, 'btn-secondary': filters.active != 1}" @click="filters.active = 1;saveFilters();page=1;loadForms();">Active</button>
					<button type="button" class="btn btn-sm" :class="{'btn-success': filters.active == 0, 'btn-secondary': filters.active != 0}" @click="filters.active = 0;saveFilters();page=1;loadForms();">Archived</button>
				</div>
				<div class="btn-group d-block" role="group" aria-label="Active / Inactive">
					<button type="button" class="btn btn-sm" :class="{'btn-primary': filters.status == 'P', 'btn-secondary': filters.status != 'P'}" @click="filters.status = 'P';saveFilters();page=1;loadForms();">Pending</button>
					<button type="button" class="btn btn-sm" :class="{'btn-success': filters.status == 'A', 'btn-secondary': filters.status != 'A'}" @click="filters.status = 'A';saveFilters();page=1;loadForms();">Approved</button>
					<button type="button" class="btn btn-sm" :class="{'btn-danger': filters.status == 'D', 'btn-secondary': filters.status != 'D'}" @click="filters.status = 'D';saveFilters();page=1;loadForms();">Declined</button>
				</div>
			</div>
			<div class="col-4">
				<label for="filter_q" class="font-weight-bold">Search</label>
				<div>
					<input type="search" v-model="filters.q" class="form-control form-control-sm" @change="saveFilters();page=1;loadForms()" />
				</div>
			</div>
		</div>

		<table class="table table-bordered table-striped">
			<thead>
				<tr>
					<th>Date</th>
					<th>ID</th>
					<th>Student ID</th>
					<th>School</th>
					<th>First Name</th>
					<th>Last Name</th>
					<th>Action</th>
				</tr>
			</thead>

			<tbody>
				<tr v-for="form in forms" :key="form.registration_specialized_transport_id">
					<td style="white-space: nowrap">{{form.created | shortDate}}</td>
					<td style="white-space: nowrap">{{form.registration_specialized_transport_id}}</td>
					<td style="white-space: nowrap">{{form.student_id}}</td>
					<td>{{schoolName(form.school_id)}}</td>
					<td>{{form.fname}}</td>
					<td>{{form.lname}}</td>
					<td style="white-space: nowrap" class="text-right"><router-link :to="'/form/specialized-transport/' + form.registration_specialized_transport_id" class="btn btn-sm btn-primary"><em class="fas fa-eye"></em> View</router-link></td>
				</tr>
			</tbody>
		</table>

		<div class="row mb-3" v-show="pages > 1">
			<nav aria-label="Next / previous pages" class="mx-auto">
				<ul class="pagination">
					<li class="page-item" :class="{'invisible': page == 1}"><button class="page-link" @click="page--;loadForms()"><em class="fas fa-chevron-left"></em> Previous {{per_page}}</button></li>
					<li class="page-item" v-for="p in pageArray" :key="p"><button class="page-link" :class="{'font-weight-bold': page == p}" @click="page = p;loadForms()">{{p}}</button></li>
					<li class="page-item" :class="{'invisible': page == pages}"><button class="page-link" @click="page++;loadForms()">Next {{per_page}} <em class="fas fa-chevron-right"></em></button></li>
				</ul>
			</nav>
		</div>
	</div>
</template>

<script>
export default
{
	name: 'FormsSpecializedTransport',
	props: ["session_id", "logged_in"],
	data: function()
	{
		return {
			forms: [],
			schools: [],
			filters: {q: "", school_id: null, active: 1, status: 'P'},
			page: 1,
			per_page: 25,
			total: 0
		}
	},
	mounted: function()
	{
		if(!this.logged_in)
		{
			return;
		}

		this.restoreFilters();
		this.loadForms();
		this.loadSchools();
	},
	computed:
	{
		pages: function()
		{
			return Math.ceil(this.total / this.per_page);
		},
		pageArray: function()
		{
			var x = new Array();

			for(var i=this.page-1; i>=this.page - 10 && i>0; i--)
			{
				x.push(i);
			}

			for(i=this.page; i<this.page + 10 && i<=this.pages; i++)
			{
				x.push(i);
			}

			// Sort numerically.
			x.sort(function(a, b){return a - b});

			return x;
		},
		offset: function()
		{
			return (this.page - 1) * this.per_page;
		},
		limit: function()
		{
			return this.page * this.per_page;
		}
	},
	methods:
	{
		loadForms: function()
		{
			var vm = this;
			vm.loading = true;
			vm.startLoading();

			this.CORS("GET", "/registration/search/specialized-transport", {"school_id": vm.filters.school_id, "active": vm.filters.active, "status": vm.filters.status, "q": vm.filters.q, "page": vm.page, "per_page": vm.per_page},
			function(response)
			{
				vm.forms = response.forms;
				vm.total = response.total;
				vm.loading = false;
				vm.stopLoading();
			}, function(response)
			{
				vm.showError("Error Loading Registration Forms", response.responseText, true, null);
				vm.loading = false;
				vm.stopLoading();
			})
		},
		loadSchools: function()
		{
			var vm = this;
			vm.startLoading();

			vm.CORS('GET', "/registration/schools", null,
			function(data)
			{
				vm.schools = data;
				vm.stopLoading();
			}, function(response)
			{
				vm.stopLoading();
				vm.showError("Error", "Error loading user schools: " + response.responseText, true, null);
			});
		},
		schoolName: function(school_id)
		{
			for(var i=0; i<this.schools.length; i++)
			{
				if(this.schools[i].school_id == school_id)
				{
					return this.schools[i].school_name;
				}
			}

			return school_id;
		},
		saveFilters: function()
		{
			if(this.filters["q"] == null || this.filters["q"] == "" || this.filters["q"] == "null")
			{
				localStorage.removeItem("q");
			}
			else
			{
				localStorage.setItem("q", String(this.filters["q"]));
			}
			if(this.filters["school_id"] == null || this.filters["school_id"] == "null")
			{
				localStorage.removeItem("school_id");
			}
			else
			{
				localStorage.setItem("school_id", String(this.filters["school_id"]));
			}
			if(this.filters["status"] == null || this.filters["status"] == "null")
			{
				localStorage.removeItem("status");
			}
			else
			{
				localStorage.setItem("status", String(this.filters["status"]));
			}
			localStorage.setItem("active", (this.filters["active"]) == 1 ? 1 : 0);
		},
		restoreFilters: function()
		{
			if(localStorage.getItem("q") != null)
			{
				this.filters["q"] = String(localStorage.getItem("q"));
			}
			if(localStorage.getItem("school_id") != null)
			{
				this.filters["school_id"] = String(localStorage.getItem("school_id"));
			}
			if(localStorage.getItem("status") != null)
			{
				this.filters["status"] = String(localStorage.getItem("status"));
			}
			if(localStorage.getItem("active") != null)
			{
				this.filters["active"] = (localStorage.getItem("active") == 1 ? 1 : 0);
			}
		}
	}
}
</script>
